import { Pipe, PipeTransform } from '@angular/core';
import { Purchase, isBillingStrategyInstant } from '@galaxy/billing';

// Evaluates whether or not a purchase can be voided
@Pipe({
  name: 'canVoidPurchase',
})
export class CanVoidPurchasePipe implements PipeTransform {
  transform(purchase: Purchase): boolean {
    if (!purchase) {
      return false;
    }

    if (isBillingStrategyInstant(purchase.billingStrategy)) {
      return !purchase.paid && !purchase.voided;
    } else {
      const now = new Date();
      const currentDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
      // an invoiced purchase can only be voided if it is for the current month, otherwise revenue has already been recognized
      const isCurrentMonth =
        purchase.timestamp.getUTCMonth() === currentDate.getUTCMonth() &&
        purchase.timestamp.getUTCFullYear() === currentDate.getUTCFullYear();

      return isCurrentMonth && !purchase.voided;
    }
  }
}
